var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{staticClass:"text-area",attrs:{"disabled":_vm.disabled,"placeholder":_vm.placeholder,"required":_vm.required},domProps:{"value":_vm.value},on:{"change":function (e) { return _vm.handleTextArea(e.target.value); }}})}
var staticRenderFns = []

export { render, staticRenderFns }